"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asFormattedAxiosError = exports.FormattedAxiosError = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
class FormattedAxiosError extends Error {
    constructor({ axiosMessage, baseUrl, message, name, responseBody, stack, statusCode, url, }) {
        super();
        this.axiosMessage = axiosMessage;
        this.baseUrl = baseUrl;
        this.message = message;
        this.name = name;
        this.responseBody = responseBody;
        this.stack = stack;
        this.statusCode = statusCode;
        this.url = url;
    }
    toJSON() {
        return Object.assign({ message: this.message, name: this.name }, lodash_1.default.omitBy({
            axiosMessage: this.axiosMessage,
            baseUrl: this.baseUrl,
            responseBody: this.responseBody,
            stack: this.stack,
            statusCode: this.statusCode,
            url: this.url,
        }, (value) => lodash_1.default.isUndefined(value)));
    }
}
exports.FormattedAxiosError = FormattedAxiosError;
const asFormattedAxiosError = (err) => {
    var _a, _b, _c, _d;
    const error = err;
    const axiosError = err;
    return new FormattedAxiosError({
        baseUrl: (_a = axiosError.config) === null || _a === void 0 ? void 0 : _a.baseURL,
        message: error.message,
        name: error.name,
        responseBody: (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data,
        stack: axiosError.stack,
        statusCode: (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status,
        url: (_d = axiosError.config) === null || _d === void 0 ? void 0 : _d.url,
    });
};
exports.asFormattedAxiosError = asFormattedAxiosError;
//# sourceMappingURL=error.js.map